import '../AnalyticsConsentInitializer/consent-init'; // injected initializer
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import EmptyLayout from '../Layout/EmptyLayout';
import { RoutesRenderer } from '../Layout/MainContent';
import './App.css';
import '../../Assets/styles/react-transitions.css';
import AuthContextProvider from '../Auth/AuthContextProvider';
import AnalyticsWrapper from '../AnalyticsWrapper';
import { ConsentContextProvider } from '../ConsentContextProvider';

function App() {
    return (
        <div className="App">
            <ConsentContextProvider>
                <AuthContextProvider>
                    <BrowserRouter>
                        <AnalyticsWrapper>
                            <div className="transition-container">
                                <RoutesRenderer defaultLayout={EmptyLayout} />
                            </div>
                        </AnalyticsWrapper>
                    </BrowserRouter>
                </AuthContextProvider>
            </ConsentContextProvider>
        </div>
    );
}

export default App;